// extracted by mini-css-extract-plugin
module.exports = {"detailsModalWrap":"PreviewBackImageModal_detailsModalWrap__HOSS8","detailsModal":"PreviewBackImageModal_detailsModal__WrUQ_"};